import { Container, Row, Col } from "react-bootstrap";
import ProductCard from "./product/ProductCard ";
import { BASE_URL } from '../constants';

// const hueData = [
//   {
//     img: "/assets/images/traditional/Earrings.png",
//     label: "Traditional Earrings",
//   },
//   {
//     img: "/assets/images/traditional/Necklaces.png",
//     label: "Traditional Necklaces",
//   },
//   {
//     img: "/assets/images/traditional/Bracelets.png",
//     label: "Traditional Bracelets",
//   },
//   {
//     img: "/assets/images/traditional/Anklets.png",
//     label: "Traditional Anklets",
//   },
// ];
const products = [
  {
    id: 1,
    category: "bracelets",
    slug: "bracelets",
    name: "Gold Charm Bracelet",
    price: 2499,
    discountPrice: 1799,
    img: "/assets/images/product/medium-size/1-9.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 2,
    category: "rings",
    slug: "rings",
    name: "Classic Gold Ring",
    price: 1999,
    discountPrice: 1399,
    img: "/assets/images/product/medium-size/1-2.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 3,
    category: "earrings",
    slug: "earrings",
    name: "Diamond Drop Earrings",
    price: 2999,
    discountPrice: 2199,
    img: "/assets/images/product/medium-size/1-5.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 4,
    category: "necklaces",
    slug: "necklaces",
    name: "Elegant Gold Necklace",
    price: 3499,
    discountPrice: 2599,
    img: "/assets/images/product/medium-size/1-3.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 5,
    category: "necklaces",
    slug: "necklaces",
    name: "Elegant Gold Necklace",
    price: 3499,
    discountPrice: 2599,
    img: "/assets/images/product/medium-size/1-3.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 6,
    category: "rings",
    slug: "rings",
    name: "Classic Gold Ring",
    price: 1999,
    discountPrice: 1399,
    img: "/assets/images/product/medium-size/1-2.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 7,
    category: "earrings",
    slug: "earrings",
    name: "Diamond Drop Earrings",
    price: 2999,
    discountPrice: 2199,
    img: "/assets/images/product/medium-size/1-5.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 8,
    category: "necklaces",
    slug: "necklaces",
    name: "Elegant Gold Necklace",
    price: 3499,
    discountPrice: 2599,
    img: "/assets/images/product/medium-size/1-3.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
];
export default function TraditionalJewel({traditionalJwalelryAllproduct=[]}) {
  
//const BASE_URL = BASE_URL; // 🔁 change if needed
//  console.log(traditionalJwalelryAllproduct,'traditionalJwalelryAllproduct');
  return (
    <section className="discover-hue" style={{ padding: "0px 0px" }}>
      <style>{`
        .discover-hue{
  // background: #f1f1f1;
}

.hue-card{
  position:relative;
//   border-radius:10px;
  overflow:hidden;
}

.hue-card img{
  width:100%;
  // border-radius:10px;
}

.hue-label{
  position: absolute;
    bottom: 10px;
    width: 80%;
    left: 50%;
    color: #fff;
    transform: translateX(-50%);
    background: #000000;
    padding: 4px 12px;
    /* border-radius: 20px; */
    font-size: 14px;
    font-weight: 600;
}


h5{
  font-weight:500;
}
  .hue-card{
  transition:0.3s;
}

.hue-card:hover{
  transform:translateY(-5px);
}
        `}</style>
      <Container>
        <div className="discover-heading ">
          <span className="text-dark">Traditional</span>
          <h2 className="text-dark">Jewelry</h2>
        </div>

        {/* <Row className="justify-content-center">
          {traditionalJwalelryAllproduct?.traditionalJwalelry.map((item, index) => (
            <Col md={3} sm={6} xs={12} key={index} className="text-center">
              <div className="hue-card">
                <span className="hue-label">{item.category_name}</span>

                <img src={BASE_URL + item.image} alt={item.category_name} />
              </div>
            </Col>
          ))}
        </Row>

        <Row className="g-1 mt-5">
          {traditionalJwalelryAllproduct.all_product.map((item) => (
            <Col key={item.id} xs={12} sm={6} md={4} lg={3} className="mb-4">
              <ProductCard {...item} />
            </Col>
          ))}
        </Row> */}
      </Container>
    </section>
  );
}
